
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trainingen",
      function () {
        return require("private-next-pages/trainingen/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trainingen"])
      });
    }
  